<div class="pt-40">
  @if (infoMessage) {
    <div class="alert alert-success font-12 pt-0">
      <strong>!</strong> {{infoMessage}}
      <button type="button" class="btn-close close-x" data-dismiss="alert" aria-label="Close" (click)="infoMessage=''">
      </button>
    </div>
  }
  <div class="hk-pg-header d-flex">
    <h4 class="hk-pg-title mt-3 col-6" translate>global.account.settings</h4>
  </div>

  <div class="hk-sec-wrapper">

    <div class="container mt-3" id="user-settings">
      <div class="row justify-content-between">
        <div class="col-5">

          @if (imgSrc) {
            <div class="profile-img">
              <img [src]="imgSrc" alt=""
                class="img-fluid rounded-circle img-thumbnail imgsrc">
              </div>
            }
            <div class="img-upload">
              <em class="fa fa-pencil cursor-pointer" aria-hidden="true" (click)="toggleUploadVisibility()"></em>
            </div>
          </div>

          <div class="col-7">
            <h4 class="hk-pg-title mt-3 mb-20" translate>global.account.personal_info</h4>
            <div class="row align-items-center">
              <div class="col-12">
                <div class="col-md-12">
                  <p class="mb-20 font-13" translate>global.account.name_surname<span>:</span>
                    <span class="font-bold"> {{fullName}}</span>
                  </p>
                </div>
                <div class="col-md-12">
                  <p class="mb-20 font-13" translate>user_mngt.role<span>:</span>
                    @for (role of roles; track role; let last = $last) {
                      <span class="font-bold">
                        {{role}}@if (!last) {
                        <span>,</span>
                      }</span>
                    }
                  </p>
                </div>
                <div class="col-md-12">
                  <p class="mb-20 font-13" translate>user_mngt.email<span>:</span>
                    <span class="font-bold"> {{email}}</span>
                  </p>
                </div>
                <div class="col-md-12">
                  <p class="mb-20 font-13" translate>common.branch<span>:</span>
                    <span class="font-bold"> {{ branchName }}</span>
                  </p>
                </div>
              </div>
            </div>

            <h4 class="hk-pg-title mt-40 mb-20" translate>global.account.change_password</h4>
            <div class="row align-items-center">
              <form [formGroup]="updatePasswordForm" (ngSubmit)="onSubmit()" class="p-0">
                <div class="col-6">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label for="oldPassword" class="font-13" translate>global.account.current_password</label>
                        <span class="requireSym">*</span>
                        <div class="relative">
                          <input [type]="oldPasswordEyeOpened ? 'text' : 'password'"
                            formControlName="oldPassword"
                            class="form-control passwordEyeInput"
                            id="oldPassword"
                            [ngClass]="{ 'is-invalid': f.oldPassword.touched && f.oldPassword.errors }"
                            />
                            <label for="oldPassword" class="passwordEye">
                              @if (f.oldPassword.value) {
                                <img
                                  (mousedown)="toggleOldPasswordEyeOpened($event, true)"
                                  (mouseup)="toggleOldPasswordEyeOpened($event, false)"
                                  (mouseleave)="toggleOldPasswordEyeOpened($event, false)"
                                  src="/assets/img/eye.svg"
                                  alt="eye"
                                  draggable="false">
                              }
                            </label>
                          </div>
                          @if (f.oldPassword.touched && f.oldPassword.errors) {
                            <span
                              class="text-danger">
                              @if (f.oldPassword.errors.required) {
                                <div translate>
                                  entity.validation.required
                                </div>
                              }
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="password" class="font-13" translate>global.account.password</label>
                          <span class="requireSym">*</span>
                          <div class="relative">
                            <input [type]="passwordEyeOpened ? 'text' : 'password'"
                              id="password"
                              formControlName="password"
                              class="form-control passwordEyeInput"
                              [ngClass]="{ 'is-invalid': f.password.touched && f.password.errors }"/>

                              <label for="password" class="passwordEye">
                                @if (f.password.value) {
                                  <img
                                    (mousedown)="togglePasswordEyeOpened($event, true)"
                                    (mouseup)="togglePasswordEyeOpened($event, false)"
                                    (mouseleave)="togglePasswordEyeOpened($event, false)"
                                    src="/assets/img/eye.svg"
                                    alt="eye"
                                    draggable="false"
                                    >
                                }
                              </label>
                            </div>
                            @if (f.password.touched && f.password.errors) {
                              <span class="text-danger">
                                @if (f.password.errors.required) {
                                  <div translate>
                                    entity.validation.required
                                  </div>
                                }
                                @if (f.password.errors?.pattern) {
                                  <div translate>
                                    entity.validation.passwordPattern
                                  </div>
                                }
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group">
                            <label for="confirmPassword" class="font-13" translate>global.account.confirm_password</label>
                            <span class="requireSym">*</span>
                            <div class="relative">
                              <input [type]="confirmPasswordEyeOpened ? 'text' : 'password'"
                                formControlName="confirmPassword"
                                class="form-control passwordEyeInput"
                                id="confirmPassword"
                                [ngClass]="{ 'is-invalid': f.confirmPassword.touched && f.confirmPassword.errors }"
                                />
                                <label for="confirmPassword" class="passwordEye">
                                  @if (f.confirmPassword.value) {
                                    <img
                                      (mousedown)="toggleConfirmPasswordEyeOpened($event, true)"
                                      (mouseup)="toggleConfirmPasswordEyeOpened($event, false)"
                                      (mouseleave)="toggleConfirmPasswordEyeOpened($event, false)"
                                      src="/assets/img/eye.svg"
                                      alt="eye"
                                      draggable="false"
                                      >
                                  }
                                </label>
                              </div>
                              @if (f.confirmPassword.touched && f.confirmPassword.errors) {
                                <span
                                  class="text-danger">
                                  @if (f.confirmPassword.errors.required) {
                                    <div translate>
                                      entity.validation.required
                                    </div>
                                  }
                                  @if (f.confirmPassword.errors.mustMatch) {
                                    <div translate>
                                      entity.validation.confirmPassword
                                    </div>
                                  }
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row justify-content-end mt-4">
                        <div class="col-md-7 col-xs-12">
                        </div>
                        <div class="col-md-5 col-xs-12 mt-20 mb-40">
                          <div class="d-grid gap-2 d-md-flex justify-content-start">
                            <app-button id="create-user" buttonClass="btn-primary"
                              buttonType="submit" >
                              <span translate>buttons.save</span>
                            </app-button>
                            <app-button id="cancel-entity" buttonClass="btn-secondary mr-0"
                              buttonType="button" (clickEvent)="returnToMainPage()">
                              <span translate>buttons.cancel</span>
                            </app-button>

                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <hr class="hr-light-30">
              </div>

              <div class="row">
                <div class="container">
                  <p-dialog [header]="titleDialog" [(visible)]="displayAlertDialog" [style]="{maxWidth: '50vw'}"
                    [modal]="true" [dismissableMask]="true">
                    <div>
                      Are you sure you want to delete the image?
                    </div>

                    <div class="row mt-30">
                      <div class="col-8 m-auto">
                        <button class="btn btn-primary col-5 mr-20"
                          type="button" (click)="confirmDelete()">Yes
                        </button>
                        <button class="btn btn-secondary col-5" type="reset" (click)="displayAlertDialog = false">
                          No
                        </button></div>
                      </div>

                    </p-dialog>

                    <p-dialog [header]="'Edit Profile Image'" [(visible)]="displayAvatarDialog" [style]="{width: '700px'}"
                      (onHide)="hideAvatarDialog()" [modal]="true" [closable]="true" [closeOnEscape]="false">
                      <div>
                        <input type="file" class="form-control" #fileInput (change)="onFileSelected($event)" style="display: none;">
                        @if (processingImgSrc) {
                          <div class="row">
                            <img [src]="processingImgSrc" #imageProfile id="imageProfile" alt="" style="max-height: 500px;">
                          </div>
                        }
                      </div>
                      <div class="row mt-20">
                        <div class="col m-auto">
                          <button class="btn btn-primary col mr-20 ml-10" type="button" (click)="openFileDialog()">Open
                          </button>
                          <button class="btn btn-primary col mr-20" type="button" (click)="removePortfolioImage();hideAvatarDialog();">Remove
                          </button>
                          <button class="btn btn-primary col mr-20" type="button" (click)="createRoundedAvatar()">Apply
                          </button>
                          <button class="btn btn-secondary col" type="reset" (click)="hideAvatarDialog()">Close
                          </button>
                        </div>
                      </div>
                    </p-dialog>
                  </div>
                </div>
              </div>
            </div>
          </div>